/**
 * Intersection Observer
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * 
 * Implementation:
 * https://medium.com/fasal-engineering/image-lazy-loading-using-browsers-intersection-observer-api-a-step-by-step-guide-with-examples-b1a867614e8
 */
namespace appn.intersectionObserver {
    export function init() {
        setTimeout(function() {
            initImgLazyLoading();
        }, 250);
    }

    /**
     * Observes the visible page and lazy loads images in when they are scrolled into view.
     */
    function initImgLazyLoading() {
        const lazyImages = [].slice.call(document.querySelectorAll('.lazy-loaded-image.lazy'));

        const lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry: IntersectionObserverEntry) {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target as HTMLImageElement;
                    lazyImage.addEventListener('load', function(e: Event) {
                        afterImageLoaded(lazyImageObserver, lazyImage);
                    });

                    lazyImage.addEventListener('error', function() {
                        afterImageLoaded(lazyImageObserver, lazyImage);
                    });

                    // Set the src - begins the image download.
                    lazyImage.src = lazyImage.dataset.imglazyurl as string;
                    lazyImage.closest('.appn-img-lazy-container')!.classList.remove('lazy');
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    }

    function afterImageLoaded(lazyImageObserver: IntersectionObserver, lazyImage: any) {
        lazyImage.classList.remove('lazy');
        lazyImage.classList.add('img-load-complete');
        lazyImageObserver.unobserve(lazyImage);
    }
}
